// extracted by mini-css-extract-plugin
export default {"container":"TreeSection_container__14TMw","noTime":"TreeSection_noTime__8N518","qute":"TreeSection_qute__suqXq","bodyText":"TreeSection_bodyText__EOJ4P"};